import { LAYOUT_COMPONENT_TYPE, navLabelFieldKey, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const navigationCafeDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.navigationCafe,
  componentType: LAYOUT_COMPONENT_TYPE.navigationHeader,
  displayOrder: 0,
  content: {
    siteTitle: loc3('Brühkraft', 'Brühkraft', 'Brühkraft'),
    [navLabelFieldKey('hours')]: loc3('Öffnungszeiten', 'Hours', 'Giờ mở cửa'),
    [navLabelFieldKey('map')]: loc3('Standort', 'Location', 'Địa điểm'),
    [navLabelFieldKey('contact')]: loc3('Kontakt', 'Contact', 'Liên hệ'),
    ctaLabel: loc3('Öffnungszeiten', 'Hours', 'Giờ mở cửa'),
    ctaHref: loc3('/#hours', '/#hours', '/#hours'),
  },
  media: {
    logoImage: '/platform/defaults/logos/nav-mark-cafe-on-light.svg',
  },
};

export const navigationBarDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.navigationBar,
  componentType: LAYOUT_COMPONENT_TYPE.navigationHeader,
  displayOrder: 0,
  content: {
    siteTitle: loc3('Velvet Room', 'Velvet Room', 'Velvet Room'),
    [navLabelFieldKey('drinks')]: loc3('Drinks', 'Drinks', 'Đồ uống'),
    [navLabelFieldKey('about')]: loc3('Über uns', 'About', 'Giới thiệu'),
    [navLabelFieldKey('contact')]: loc3('Kontakt', 'Contact', 'Liên hệ'),
    ctaLabel: loc3('Event buchen', 'Book an event', 'Đặt sự kiện'),
    ctaHref: loc3('/#party', '/#party', '/#party'),
  },
  media: {
    logoImage: '/platform/defaults/logos/nav-mark-bar-on-dark.svg',
  },
};

export const navigationFoodTruckDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.navigationFoodTruck,
  componentType: LAYOUT_COMPONENT_TYPE.navigationHeader,
  displayOrder: 0,
  content: {
    siteTitle: loc3('Rolling Kitchen', 'Rolling Kitchen', 'Rolling Kitchen'),
    [navLabelFieldKey('menu')]: loc3('Menü', 'Menu', 'Thực đơn'),
    [navLabelFieldKey('location')]: loc3('Standort', 'Find us', 'Vị trí'),
    [navLabelFieldKey('contact')]: loc3('Kontakt', 'Contact', 'Liên hệ'),
    ctaLabel: loc3('Standort', 'Find us', 'Vị trí'),
    ctaHref: loc3('/#location', '/#location', '/#location'),
  },
  media: {
    logoImage: '/platform/defaults/logos/nav-mark-food-truck-on-light.svg',
  },
};
